import { Reducer } from "redux";

import { LoggedInUserDetailsActionDispatchTypes } from "../constants/User";
import { LoggedInUserResponse } from "../models/api/User";
import { LoggedInUserActionTypes } from "../models/dispatchTypes/User";

export const initialState: LoggedInUserResponse = {
  loading: false,
  response: {
    providerPortalUser: {
      userId: "",
      userName: "",
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      status: "",
      twoFactorEnabled: true,
      accessFailedCount: true,
      registrationDate: "",
      registrationSource: "",
      approver: null,
      mfaId: 0,
      mfaType: "",
      roleId: "",
      roleType: "",
      userCreated: "",
    },
    userProviderList: [],
  },
  error: null,
  flow: 0,
};

const LoggedInUserReducer: Reducer<
  LoggedInUserResponse,
  LoggedInUserActionTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case LoggedInUserDetailsActionDispatchTypes.USER_MANAGEMENT_LOADING: {
      return {
        ...state,
        loading: true,
        error: null,
      };
    }
    case LoggedInUserDetailsActionDispatchTypes.USER_MANAGEMENT_SUCCESS: {
      return {
        ...state,
        response: action.response,
        flow: action.flow,
        loading: false,
        error: null,
      };
    }
    case LoggedInUserDetailsActionDispatchTypes.USER_MANAGEMENT_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    }
    case LoggedInUserDetailsActionDispatchTypes.USER_MANAGEMENT_RESET: {
      return initialState;
    }
  }
  return state;
};

export default LoggedInUserReducer;
